<template>
  <div class="education-components">
    <div class="education">
      <div class="jumbotron">
        <img src="../assets/img/education/jumbotron.jpg" alt="" class="over_display">
        <img src="../assets/img/education/jumbotron_under.jpg" alt="" class="under_display">
      </div>
      <div class="catch-wrapper">
        <img src="../assets/img/education/catch.png" alt="店舗に立つ前も、立ってからも。sanwaには、数多くの人材を育成してきた研修があります。" width="450px">
      </div>
      <div class="main-contents-wrapper">
        <div class="genre-wrapper">
          <div class="headline">
            <p class="number">
              01
            </p>
            <p class="title">
              新入社員向け社員研修の例
            </p>
          </div>
          <p class="info">- 店舗に配属される前</p>
          <ExampleContent title="合宿研修" message="4泊5日。集団行動を通じて、役割意識のもと「考えて行動する」ことや、切磋琢磨できる同期とのつながりを築くためのもの。社会人としての基礎やマナーをはじめ、企業理念、仕事の基本的な知識と接客を学びます。" />
          <ExampleContent title="外部講師研修" message="3～5日間（年により変動）。社会人として必要な考え方や心のあり方、店舗に配属された際に必要な技術を実践的な研修で習得します（例／レジ、接客、POP、各部門で用いる機器の使い方など）。" />
          <p class="info">- 店舗に配属された後</p>
          <ExampleContent title="集合研修" message="月1回実施（繁忙期の8月、12月を除く）。現状の仕事内容を同期たちと共有。「自分がどこまでできているのか」を客観的に理解するもの。仕事の悩みも共有することで、頭と気持ちの整理を促します。" />
          <ExampleContent title="メンター制度" message="2～5年目社員をメンター（指導者）として、新入社員をフォローする制度。月1回の面談や隔月の食事を通して、仕事と向き合う気持ちのケアなどを行います。メンターは基本、同じ店舗で異なる部門の先輩が担当します。" />
        </div>
        <div class="genre-wrapper">
          <div class="headline">
            <p class="number">
              02
            </p>
            <p class="title">
              階層別研修の例
            </p>
          </div>
          <ExampleContent title="2～4年次研修" message="入社2〜4年目が対象。3ヶ月に1回実施。チーフになるなど徐々に立場が変わることを受け、現状の共有や、「今後に向けてどのように仕事と向き合っていくべきか」を確認できる場。" />
          <ExampleContent title="チーフ資格研修" message="入社3年目以降が対象。選抜された社員を対象に実施されるチーフ資格試験にあたっての、対策の研修です（チーフ職に必要な考え方や数字管理などの勉強会）。" />
          <ExampleContent title="チーフ研修" message="各部門ごとに、不定期で開催。チーフとしての能力を高めるための研修です。現状の部門の数値や、本部の方針を共有する場でもあります。" />
          <ExampleContent title="店長研修" message="不定期で開催。店長会議が主です。会社の政策・方針を共有。また、会社として目標とする数値や、「今後店長としてどうすべきか」などのアドバイスも受けられます。" />
          <ExampleContent title="シニアキャリア研修" message="50歳以上の全社員が対象。次世代の社員の模範となるため、自身のキャリアを再認識する場です。" />
        </div>
        <div class="genre-wrapper">
          <div class="headline">
            <p class="number">
              03
            </p>
            <p class="title">
              部門別研修の例
            </p>
          </div>
          <ExampleContent title="センター研修<br>（畜産部・水産部・惣菜部）" message="店舗へ納品する商品を製造しているプロセスセンターで、ライン作業を実習します。畜産部・水産部は手切り研修も実施。商品の数値管理の技法も学びます。" />
          <ExampleContent title="グロサリー売場研修" message="月1回開催。対象者は、若手～中堅社員をランダムに選出。講師は、グロサリー部の元部長（現顧問）。売場のあり方、スーパーマーケットの基礎知識および現状を共有・指導します。" />
          <ExampleContent title="部門別研修" message="一例をご紹介。◎畜産部の場合：日本ハム工場見学（メーカーを訪問して商品の製造過程を知る。また、実際に製造に携わって試食）。◎グロサリー部の場合：食品卸会社の展示会に参加（普段取り扱う商品を知り、理解を深める）。" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExampleContent from '@/components/education/ExampleContent.vue'
export default {
  name: 'Education',
  components: {
    ExampleContent
  }
}
</script>
<style scoped lang="scss">
.education {
  padding-bottom: 100px;
  &:before {
    content: "";
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    left: 0;
    top: 800px;
    z-index: -1;
    background-image: linear-gradient(0deg,	#f0f0f0 25%,transparent 25%,transparent 50%,#f0f0f0 50%,#f0f0f0 75%,transparent 75%,transparent);
    background-size: 120px 120px;
  }
  &:after {
    content: "";
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    right: 0;
    top: 0;
    z-index: -1;
    background-image: linear-gradient(0deg,	#f0f0f0 25%,transparent 25%,transparent 50%,#f0f0f0 50%,#f0f0f0 75%,transparent 75%,transparent);
    background-size: 120px 120px;
  }
}
.jumbotron {
  margin: 0 auto;
  max-width: 1300px;
  width: 100%;
  img {
    vertical-align: middle;
  }
}
.catch-wrapper {
  margin: 0 auto;
  max-width: 750px;
  width: 100%;
  margin-top: -100px;
  @media print, screen and (max-width: 750px) {
    margin-top: -10px;
    width: 90%;
  }
}
.main-contents-wrapper {
  max-width: 750px;
  margin: 0 auto;
  margin-top: 100px;
  @media print, screen and (max-width: 750px) {
    width: 90%;
    margin-top: 50px;
  }
}
.genre-wrapper {
  .headline {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  .number {
    background-color: #e51c57;
    color: #fff;
    padding: 10px 15px;
    margin-right: 20px;
  }
  .title {
    font-size: 18px;
    color: #e51c57;
  }
}
.genre-wrapper + .genre-wrapper {
  margin-top: 50px;
}
.info {
  font-size: 13px;
  color: #e51c57;
}
</style>
